import React from 'react';
import { Button, Typography } from 'seagull';
import { PaymentTerms } from 'seagull/icons';
import { StepPage } from "../../components/StepPage";
import { useResponsive } from "../../contexts";
import PackageSelector from "./PackageSelector";
import styles from "./PackagesStep.module.scss";
import { COBStep, getStepName } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
export default function PackagesStep(_ref) {
  var _relationship$service, _relationship$service2;
  let {
    selectedBundleID,
    onSelectBundleID,
    onClickNext,
    onClickBack
  } = _ref;
  const {
    isMobile
  } = useResponsive();
  const {
    relationship
  } = useCobConfig();
  const {
    CUSTOM_BRANDING = false
  } = useFeatureFlags();
  return /*#__PURE__*/React.createElement(StepPage, {
    header: getStepName(COBStep.selectAPackage, relationship),
    primaryBtn: /*#__PURE__*/React.createElement(Button, {
      "data-testid": "packages-step-next-btn",
      onClick: () => onClickNext()
    }, "Next"),
    backBtnTestid: "packages-step-back-btn",
    onBackBtnClick: onClickBack,
    testid: "packages-step",
    errorTestid: "packages-step-error"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.sectionTitle
  }, !CUSTOM_BRANDING && /*#__PURE__*/React.createElement(PaymentTerms, null), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    weight: "normal"
  }, "Packages")), /*#__PURE__*/React.createElement(PackageSelector, {
    packages: (_relationship$service = (_relationship$service2 = relationship.serviceBundles) === null || _relationship$service2 === void 0 ? void 0 : _relationship$service2.bundles) !== null && _relationship$service !== void 0 ? _relationship$service : [],
    selectedBundleID: selectedBundleID,
    isMobile: isMobile,
    CUSTOM_BRANDING: CUSTOM_BRANDING,
    onSelect: id => onSelectBundleID(id)
  }));
}